import { j as p } from "../../jsx-runtime-ClSzPYp4.js";
import E from "../../Footer/Footer.mjs";
import "../../colors-C72eWVhK.js";
import { SCREEN_WIDTHS as d } from "../../common/themes/constants/constants.mjs";
import { useBrand as f } from "../../providers/BrandProvider/brandProvider.mjs";
import { C as r, L as N, d as T, O as C, P as I, T as _, V as c, c as l } from "../../brands-CoixlYYY.js";
import o from "./footerContent.mjs";
const A = [
  r,
  N,
  T,
  C,
  I,
  _,
  c,
  l
], j = ({ allowList: t = A, footerContent: s = o, variant: a = "light", maxWidth: m = d.EIGHT_COLUMN_NO_PADDING, ...n }) => {
  const e = f(t), { links: i, copyright: O } = s[e] || o[r];
  return /* @__PURE__ */ p.jsx(E, {
    links: i,
    copyright: O,
    maxWidth: m,
    variant: a,
    ...n
  });
};
export {
  j as default
};
